import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("cm-theme");
    return saved || "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    // Add a short-lived "theme-transitioning" class so background/color shifts
    // animate during the swap. We remove it after ~260ms (slightly longer than
    // the 220ms transition) so normal interaction stays snappy and shadows
    // aren't slowed down by an ambient transition rule.
    root.classList.add("theme-transitioning");
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("cm-theme", theme);
    const t = setTimeout(() => root.classList.remove("theme-transitioning"), 260);
    return () => clearTimeout(t);
  }, [theme]);

  const toggle = () => setTheme(prev => prev === "light" ? "dark" : "light");

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
